// @mui
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

export default function StyledNotistack() {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={{
        '#root': {
          '.notistack-MuiContent': {
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(1.5),
            borderRadius: theme.shape.borderRadius,
            fontWeight: 800,
            fontSize: theme.typography.pxToRem(15),
            boxShadow: `0 0 0 1px ${theme.palette.success.main}`,

            '&.notistack-MuiContent-success': {
              backgroundColor: theme.palette.success.lighter,
              border: `1px solid ${theme.palette.success.light}`,
              color: theme.palette.success.dark,
              boxShadow: `0 0 0 1px ${theme.palette.success.main}`,
            },
            '&.notistack-MuiContent-error': {
              backgroundColor: theme.palette.error.lighter,
              border: `1px solid ${theme.palette.error.light}`,
              color: theme.palette.error.dark,
              boxShadow: `0 0 0 1px ${theme.palette.error.main}`,
            },
            '&.notistack-MuiContent-warning': {
              backgroundColor: theme.palette.warning.lighter,
              border: `1px solid ${theme.palette.warning.light}`,
              color: theme.palette.warning.dark,
              boxShadow: `0 0 0 1px ${theme.palette.warning.main}`,
            },
            '&.notistack-MuiContent-info': {
              backgroundColor: theme.palette.info.lighter,
              border: `1px solid ${theme.palette.info.light}`,
              color: theme.palette.info.dark,
              boxShadow: `0 0 0 1px ${theme.palette.info.main}`,
            },
          },

          '.SnackbarItem-message': {
            display: 'flex',
            flexDirection: 'column',
            padding: '0 !important',
            fontWeight: theme.typography.fontWeightMedium,
            '& > span': {
              marginLeft: theme.spacing(1),
            },
            '& > div': {
              fontSize: 13,
              color: theme.palette.grey[600],
              fontWeight: theme.typography.fontWeightRegular,
              marginTop: 2,
            },
          },

          '.SnackbarItem-action': {
            marginLeft: 'auto',
            '& svg': {
              width: 20,
              height: 20,
              color: 'inherit',
            },
          },
        },
      }}
    />
  );
}
